/**
 * @ngdoc directive
 * @name directiveDatePickerWrapper
 * @restrict A
 *
 * @description
 * Directive for date picker.
 */
export default function () {
    return {
        restrict: 'A', // Only attribute name can be used for directive definition
        scope: {},
        controller: 'directiveDatePickerWrapperCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/datePickerWrapper.js